export default __webpack_public_path__ + "static/media/preflop-equity-handvshand_0015_thumb.ab246e79.jpg";